export const QA_NAME_APPLICANT_PROFILE_INFO_PORTAL = 'applicantInfoPortal'

export const QA_NAME_APPLICANT_PROFILE_PHASE_BAR = 'applicantPhaseBar'

export const APPLICANT_PROFILE_HEADER_INFO_ITEMS_COLUMNS = 3

export const APPLICANT_PROFILE_HEADER_INFO_ITEMS_LOADING_LENGTH = 3

export const APPLICANT_PROFILE_INFO_ITEM_TITLE_KEY = {
  followUp: 'RentalPortal.ApplicantProfileFollowUpKey',
  portalReceived: 'RentalPortal.ApplicantProfilePortalReceivedLabelKey',
  responsibleManager: 'RentalPortal.ListingProfileResponsibleManagerKey',
}

export const APPLICANT_PHASE_STATE = {
  active: 'active',
  done: 'done',
  upcoming: 'upcoming',
}

export const APPLICANT_PHASE_TERMINAL_REASON = {
  rejected: 'rejected',
  withdrawn: 'withdrawn',
}

export const APPLICANT_PHASE_TERMINAL_STATEMENT_KEY = {
  [APPLICANT_PHASE_TERMINAL_REASON.rejected]:
    'RentalPortal.ApplicantPhaseTerminalRejectedKey',
  [APPLICANT_PHASE_TERMINAL_REASON.withdrawn]:
    'RentalPortal.ApplicantPhaseTerminalWithdrawnKey',
}
